import { ArrowForwardIos, Message, RocketLaunch } from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";

export default memo(({ isConnectable }) => {
  return (
    <div
      style={{
        width: "300px",
        backgroundColor: "#FFFFFF",
        padding: "16px",
        borderRadius: "14px",
        boxShadow: "0 10px 28px rgba(26, 31, 54, 0.10)"
      }}
    >
      <div
        style={{
          color: "#17181F",
          fontSize: "16px",
          flexDirection: "row",
          display: "flex"
        }}
      >
        <RocketLaunch
          sx={{
            width: "20px",
            height: "20px",
            marginRight: "8px",
            color: "#4450FF"
          }}
        />
        <div style={{ color: "#17181F", fontSize: "16px", fontWeight: 800 }}>
          Início do fluxo
        </div>
      </div>
      <div style={{ color: "#73768A", fontSize: "12px", marginTop: "8px", lineHeight: 1.45 }}>
        Este bloco marca o início do seu fluxo.
      </div>
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#4450FF",
          width: "18px",
          height: "18px",
          top: "70%",
          right: "-11px",
          cursor: 'pointer'
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffff",
            width: "10px",
            height: "10px",
            marginLeft: "2.9px",
            marginBottom: "1px",
            pointerEvents: 'none'
          }}
        />
      </Handle>
    </div>
  );
});
